window.browser.extension.inIncognitoContext = false
